module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vue-timetable vue-timetable-week-mode",
    attrs: {
      "data-view": "week",
      "id": "timetable-3"
    }
  }, [_c('div', {
    staticClass: "vue-timetable-hours"
  }, _vm._l(((_vm.date.hours.end - (_vm.date.hours.start - 1))), function(i) {
    return _c('div', {
      staticClass: "vue-timetable-hour",
      style: ({
        height: _vm.height + 'px'
      })
    }, [_c('span', [_vm._v(_vm._s(i + (_vm.date.hours.start - 1)) + ":00")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "vue-timetable-content"
  }, [_c('div', {
    staticClass: "vue-timetable-columns"
  }, _vm._l((_vm.date.list), function(day) {
    return _c('div', {
      staticClass: "vue-timetable-column"
    }, [_vm._t("header", function() {
      return [_c('div', {
        staticClass: "vue-timetable-column-header"
      }, [_vm._v("\n              " + _vm._s(_vm._f("moment")(day.date, "dddd"))), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(day.date, "DD/MM/YYYY")))])])]
    }, {
      "day": day
    }), _vm._v(" "), _c('div', {
      staticClass: "vue-timetable-column-content"
    }, _vm._l((day.events), function(event) {
      return _c('span', {
        staticClass: "vue-timetable-event",
        style: ({
          top: event.placement.top + 'px',
          height: event.placement.height + 'px',
          backgroundColor: event.color
        })
      }, [_vm._t("default", function() {
        return [_c('span', [_vm._v(_vm._s(event.text))])]
      }, {
        "event": event
      })], 2)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "vue-timetable-column-grid"
    }, _vm._l(((_vm.date.hours.end - _vm.date.hours.start)), function(i) {
      return _c('div', {
        staticClass: "vue-timetable-grid-item",
        style: ({
          height: (_vm.height - 1) + 'px'
        })
      })
    }), 0)], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c36a662"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-timetable/components/WeekTimetable.vue
// module id = 715
// module chunks = 1